import React from 'react';
import { StatsPage } from './stats/StatsPage';
export const StatsSection = () => {
  return <StatsPage data-id="element-21113" />;
};